// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container principal do card de endereço */
._p4uT8 {
  width: 100%;
  align-self: stretch;
}

.flRfVx {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  background: var(--info-card-background);
  border-radius: var(--radius-s);
  padding: var(--spacing-2);
  text-align: left;
}

.C9VNjX {
  color: var(--icon-primary-medium);
  font-size: var(--font-size-lg);
  flex-shrink: 0;
}

.Trtuph {
  flex: 1;
}

.NQOPLQ {
  font-family: var(--font-family-base);
  font-size: var(--type-subtitle-md-font-size);
  font-weight: var(--type-subtitle-md-font-weight);
  line-height: var(--type-subtitle-md-line-height);
  color: var(--text-neutral-dark);
}

.WMHvoY {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.i2A6RF {
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-md-font-size);
  font-weight: var(--type-paragraph-md-regular-font-weight);
  line-height: var(--type-paragraph-md-regular-line-height);
  color: var(--text-neutral-dark);
}

.aVSqlg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.Kz8EKd {
  background: transparent;
  border: none;
  color: var(--icon-primary-bright);
  font-family: var(--font-family-base);
  font-size: var(--type-label-md-font-size);
  font-weight: var(--type-label-md-font-weight);
  line-height: var(--type-label-md-line-height);
  cursor: pointer;
  padding: var(--spacing-1) var(--spacing-1-5);
  border-radius: var(--radius-s);
  transition: var(--transition-color);
}

.Kz8EKd:hover:not(:disabled) {
  color: var(--icon-primary-medium);
}

.Kz8EKd:disabled {
  opacity: var(--opacity-0-5);
  cursor: not-allowed;
}

/* Botão "Definir" para quando não há endereço */
.CBuJpA {
  background: var(--surface-primary-bright);
  border: none;
  color: var(--on-surface-neutral-white);
  font-family: var(--font-family-base);
  font-size: var(--type-label-md-font-size);
  font-weight: var(--type-label-md-font-weight);
  line-height: var(--type-label-md-line-height);
  cursor: pointer;
  padding: var(--spacing-1) var(--spacing-1-5);
  border-radius: var(--radius-s);
  transition: var(--transition-color);
}

.CBuJpA:hover:not(:disabled) {
  background-color: var(--surface-primary-medium);
}

.CBuJpA:disabled {
  opacity: var(--opacity-0-5);
  cursor: not-allowed;
}

/* Responsividade */
@media (max-width: 768px) {
  .flRfVx {
    flex-direction: column;
    text-align: center;
    gap: var(--spacing-1-5);
  }

  .Kz8EKd {
    align-self: center;
  }

  .CBuJpA {
    align-self: center;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/AddressCard/AddressCard.module.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uCAAuC;EACvC,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,gDAAgD;EAChD,gDAAgD;EAChD,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,yDAAyD;EACzD,yDAAyD;EACzD,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iCAAiC;EACjC,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;EAC7C,eAAe;EACf,4CAA4C;EAC5C,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,yCAAyC;EACzC,YAAY;EACZ,sCAAsC;EACtC,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;EAC7C,eAAe;EACf,4CAA4C;EAC5C,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Container principal do card de endereço */\n.infoList {\n  width: 100%;\n  align-self: stretch;\n}\n\n.infoItem {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n  background: var(--info-card-background);\n  border-radius: var(--radius-s);\n  padding: var(--spacing-2);\n  text-align: left;\n}\n\n.infoIcon {\n  color: var(--icon-primary-medium);\n  font-size: var(--font-size-lg);\n  flex-shrink: 0;\n}\n\n.infoContent {\n  flex: 1;\n}\n\n.infoLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--type-subtitle-md-font-size);\n  font-weight: var(--type-subtitle-md-font-weight);\n  line-height: var(--type-subtitle-md-line-height);\n  color: var(--text-neutral-dark);\n}\n\n.infoValueContainer {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.infoValue {\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-md-font-size);\n  font-weight: var(--type-paragraph-md-regular-font-weight);\n  line-height: var(--type-paragraph-md-regular-line-height);\n  color: var(--text-neutral-dark);\n}\n\n.validIcon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.changeButton {\n  background: transparent;\n  border: none;\n  color: var(--icon-primary-bright);\n  font-family: var(--font-family-base);\n  font-size: var(--type-label-md-font-size);\n  font-weight: var(--type-label-md-font-weight);\n  line-height: var(--type-label-md-line-height);\n  cursor: pointer;\n  padding: var(--spacing-1) var(--spacing-1-5);\n  border-radius: var(--radius-s);\n  transition: var(--transition-color);\n}\n\n.changeButton:hover:not(:disabled) {\n  color: var(--icon-primary-medium);\n}\n\n.changeButton:disabled {\n  opacity: var(--opacity-0-5);\n  cursor: not-allowed;\n}\n\n/* Botão \"Definir\" para quando não há endereço */\n.defineButton {\n  background: var(--surface-primary-bright);\n  border: none;\n  color: var(--on-surface-neutral-white);\n  font-family: var(--font-family-base);\n  font-size: var(--type-label-md-font-size);\n  font-weight: var(--type-label-md-font-weight);\n  line-height: var(--type-label-md-line-height);\n  cursor: pointer;\n  padding: var(--spacing-1) var(--spacing-1-5);\n  border-radius: var(--radius-s);\n  transition: var(--transition-color);\n}\n\n.defineButton:hover:not(:disabled) {\n  background-color: var(--surface-primary-medium);\n}\n\n.defineButton:disabled {\n  opacity: var(--opacity-0-5);\n  cursor: not-allowed;\n}\n\n/* Responsividade */\n@media (max-width: 768px) {\n  .infoItem {\n    flex-direction: column;\n    text-align: center;\n    gap: var(--spacing-1-5);\n  }\n\n  .changeButton {\n    align-self: center;\n  }\n\n  .defineButton {\n    align-self: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoList": `_p4uT8`,
	"infoItem": `flRfVx`,
	"infoIcon": `C9VNjX`,
	"infoContent": `Trtuph`,
	"infoLabel": `NQOPLQ`,
	"infoValueContainer": `WMHvoY`,
	"infoValue": `i2A6RF`,
	"validIcon": `aVSqlg`,
	"changeButton": `Kz8EKd`,
	"defineButton": `CBuJpA`
};
module.exports = ___CSS_LOADER_EXPORT___;
